// core
import { Component, Input, OnInit, Renderer2, Inject, SimpleChanges, OnChanges } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// gamut
import { GamutBrandingService } from '@campfire-nx/gamut';

/*
//This is what this component willl look like in open-portal app-partner-style component
<app-partner-style *ngIf="partnerBrandService.data && partnerBrandService.data.brand">
  <gamut-branding [brand]="partnerBrandService.data.brand" [scope]=":root"></gamut-branding>
</app-partner-style>
*/

@Component({
  selector: 'gamut-branding',
  templateUrl: './gamut-branding.component.html',
  styleUrls: ['./gamut-branding.component.scss']
})
export class GamutBrandingComponent implements OnInit {
  @Input() brand!: any;
  @Input() scope!: string;
  @Input() endpoint!: string;

  public stylesheet!: SafeHtml;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private domSanitizer: DomSanitizer,
    private gamutBrandingService: GamutBrandingService
  ) {}

  ngOnInit(): void {
    this.outputBranding();
  }

  ngOnChanges(changes: SimpleChanges) { 
    if (
      typeof changes.brand.currentValue === 'object' &&
      changes.brand.currentValue?.logoLarge !== changes.brand.previousValue?.logoLarge &&
      !changes.brand.isFirstChange()
    ) {
      this.outputBranding();
    } 
  }

  outputBranding() {
    if (this.brand) {
      const apiBrand = this.joinBrandToApi(this.brand);
      const mapBrand = this.gamutBrandingService.mapBrandedStyleVariables(apiBrand);
      const styleScope = (this.scope || ":root"); // if no scope is set add variables to the :root

      this.stylesheet = this.domSanitizer.bypassSecurityTrustHtml(
      [
`<style>
` + styleScope + ` {`,
  this.gamutBrandingService.createBrandedStyleVariables(mapBrand),
`
}
</style>`
        ].join('')
      );

      // Add assets to document if root scope
      if (styleScope === ":root") {
        this.addFonts(mapBrand);
        this.addFavicons(mapBrand);
      }
    }
  }

  joinBrandToApi(brand: any) {
    var apiBrand: any = {};
    var apiEndpoint = (this.endpoint)? this.endpoint: '';

    for (let key in brand) {
      if (key === 'favicon' || key === 'logoSmall' || key === 'logoLarge') {
        apiBrand[key] = apiEndpoint + brand[key];
      }
      else {
        apiBrand[key] = brand[key];
      }
    }

    return apiBrand;
  }

  hasLinkHref(resource: any) {
    var links = this.document.getElementsByTagName('link');
    for (let i = 0, j = links.length; i < j; i++) {
      if (links[i].href === resource) {
        return true;
      }
    }

    return false;
  }
  addFonts(brand: any) {
    var bodyFontUrl = this.gamutBrandingService.getStyleMapValue(brand, "--theme-body-url");
    if (bodyFontUrl && !this.hasLinkHref(bodyFontUrl)) {
      let bodyFont = this.renderer.createElement('link');
      bodyFont.rel = 'stylesheet';
      bodyFont.href = bodyFontUrl;
      this.renderer.appendChild(this.document.head, bodyFont);
    }
    var titleFontUrl = this.gamutBrandingService.getStyleMapValue(brand, "--theme-title-url");
    if (titleFontUrl  && !this.hasLinkHref(titleFontUrl)) {
      let titleFont = this.renderer.createElement('link');
      titleFont.rel = 'stylesheet';
      titleFont.href = titleFontUrl;
      this.renderer.appendChild(this.document.head, titleFont);
    }
  }

  addFavicons(brand: any) {
    // Add the partner favicon to head tag
    var favicon = this.gamutBrandingService.getStyleMapValue(brand, "--theme-favicon");
    if (favicon) {
      let openFavicon = this.document.getElementById('openFavicon');
      openFavicon?.setAttribute('href', favicon + '?=' + Math.random());
    }
  }

}
